import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enDashboard from './locales/en/dashboard.json';
import enMeals from './locales/en/meals.json';
import enShopping from './locales/en/shopping.json';
import enChores from './locales/en/chores.json';
import enRecipes from './locales/en/recipes.json';
import enFamily from './locales/en/family.json';
import enForms from './locales/en/forms.json';
import enNotifications from './locales/en/notifications.json';

import svCommon from './locales/sv/common.json';
import svNavigation from './locales/sv/navigation.json';
import svDashboard from './locales/sv/dashboard.json';
import svMeals from './locales/sv/meals.json';
import svShopping from './locales/sv/shopping.json';
import svChores from './locales/sv/chores.json';
import svRecipes from './locales/sv/recipes.json';
import svFamily from './locales/sv/family.json';
import svForms from './locales/sv/forms.json';
import svNotifications from './locales/sv/notifications.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    dashboard: enDashboard,
    meals: enMeals,
    shopping: enShopping,
    chores: enChores,
    recipes: enRecipes,
    family: enFamily,
    forms: enForms,
    notifications: enNotifications,
  },
  sv: {
    common: svCommon,
    navigation: svNavigation,
    dashboard: svDashboard,
    meals: svMeals,
    shopping: svShopping,
    chores: svChores,
    recipes: svRecipes,
    family: svFamily,
    forms: svForms,
    notifications: svNotifications,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: true, // Enable debug mode to see what's happening
    
    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    // Namespace options
    defaultNS: 'common',
    ns: ['common', 'navigation', 'dashboard', 'meals', 'shopping', 'chores', 'recipes', 'family', 'forms', 'notifications'],
    
    // React options
    react: {
      useSuspense: false,
    },
  }).then(() => {
    console.log('i18n initialized with resources:', i18n.language, i18n.options.resources);
    console.log('Available namespaces:', i18n.options.ns);
    console.log('Current language:', i18n.language);
  });

export default i18n;
